import axios from "../axios";
import * as fetchResponseHandling from "./../responseHandling/fetch"
import * as createResponseHandling from "./../responseHandling/create"
import * as updateResponseHandling from "./../responseHandling/update"
import * as deleteResponseHandling from "./../responseHandling/delete"

async function fetchCourse(courseId) {
  const res = await axios.get(`/teachers/courses/${courseId}`);
  return fetchResponseHandling.parseResponse(res);
}

async function fetchCourses(libraryId) {
  const res = await axios.get(`/teachers/courses?course[library_id]=${libraryId}`);
  return fetchResponseHandling.parseResponse(res);
}

async function createCourse(body) {
  const res = await axios.post(`/teachers/courses`, body, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
  });
  return createResponseHandling.parseResponse(res);
}

async function updateCourse(courseId, formData) {
  const res = await axios.put(`/teachers/courses/${courseId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
  });
  return updateResponseHandling.parseResponse(res);
}

async function deleteCourse(courseId) {
  const res = await axios.delete(`/teachers/courses/${courseId}`);
  return deleteResponseHandling.parseResponse(res);
}

async function orderLessonPositions(courseId, body) {
  const res = await axios.put(`/teachers/lesson_orders/${courseId}`, body);
  return updateResponseHandling.parseResponse(res);
}

export {
  fetchCourse,
  fetchCourses,
  createCourse,
  updateCourse,
  deleteCourse,
  orderLessonPositions
};
